var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileInvoiceDollar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 26.666,
    viewBox: "0 0 20 26.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#405cfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab5fc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-invoice-dollar",
    "data-name": "Icon awesome-file-invoice-dollar",
    d: "M19.635,5.469l-5.1-5.1A1.249,1.249,0,0,0,13.651,0h-.318V6.667H20V6.349A1.246,1.246,0,0,0,19.635,5.469ZM11.667,7.083V0H1.25A1.247,1.247,0,0,0,0,1.25V25.416a1.247,1.247,0,0,0,1.25,1.25h17.5A1.247,1.247,0,0,0,20,25.416V8.333H12.917A1.254,1.254,0,0,1,11.667,7.083ZM3.333,3.75a.417.417,0,0,1,.417-.417H7.917a.417.417,0,0,1,.417.417v.833A.417.417,0,0,1,7.917,5H3.75a.417.417,0,0,1-.417-.417Zm0,4.167V7.083a.417.417,0,0,1,.417-.417H7.917a.417.417,0,0,1,.417.417v.833a.417.417,0,0,1-.417.417H3.75A.417.417,0,0,1,3.333,7.917Zm7.5,13.744v1.256a.417.417,0,0,1-.417.417H9.583a.417.417,0,0,1-.417-.417V21.651a2.982,2.982,0,0,1-1.634-.591.417.417,0,0,1-.03-.632l.612-.584a.427.427,0,0,1,.528-.038A1.254,1.254,0,0,0,9.31,20h1.464a.655.655,0,0,0,.615-.687.68.68,0,0,0-.457-.663l-2.344-.7a2.357,2.357,0,0,1-1.645-2.26,2.319,2.319,0,0,1,2.222-2.347V12.083a.417.417,0,0,1,.417-.417h.833a.417.417,0,0,1,.417.417v1.265a2.978,2.978,0,0,1,1.634.591.417.417,0,0,1,.03.632l-.612.584a.427.427,0,0,1-.528.038A1.249,1.249,0,0,0,10.689,15H9.225a.655.655,0,0,0-.615.687.68.68,0,0,0,.457.663l2.344.7a2.357,2.357,0,0,1,1.645,2.26A2.319,2.319,0,0,1,10.833,21.66Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInvoiceDollar);
export default __webpack_public_path__ + "static/media/file-invoice-dollar.a6beb3225aa2ea9669aef07b1673ec20.svg";
export { ForwardRef as ReactComponent };